import React from "react";
import { MapPin } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { LogoMark } from "./LogoMark";

const LEGAL_LINE =
  "Punteria Bartesaghi di Bartesaghi Alfredo & C. snc — Via Roma, 93 — 23868 Valmadrera (LC) — P.IVA: 02089560136 — CCIAA di Lecco REA 239998 — Reg. Imprese 02089560136";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer">
      <div className="bg-[#11261b] text-white/70 py-10 border-t border-white/10">
        <div className="pb-container flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div data-testid="footer-logo" className="flex items-center gap-3">
            <LogoMark size={64} alt="Punteria Bartesaghi logo" />
            <span className="flex items-baseline gap-2">
              <span className="font-heading font-black text-white text-base uppercase tracking-tight">
                Punteria
              </span>
              <span className="font-heading font-light text-white text-base uppercase tracking-tight">
                Bartesaghi
              </span>
            </span>
          </div>

          <div
            data-testid="footer-address"
            className="flex items-center gap-2 text-xs text-white/60"
          >
            <MapPin className="w-3.5 h-3.5 text-[#c9a84c]" strokeWidth={1.5} />
            <span>{t.footer.address}</span>
          </div>

          <p className="text-xs uppercase tracking-[0.2em] text-white/50">
            {t.footer.tagline}
          </p>
          <p className="text-xs text-white/50">
            © {year} Punteria Bartesaghi S.n.c. · {t.footer.rights}
          </p>
        </div>
      </div>

      {/* Legal / company info bar */}
      <div
        data-testid="legal-bar"
        className="bg-[#0a1a12] border-t border-white/5"
      >
        <div className="pb-container py-4 text-center">
          <p className="text-[11px] md:text-xs leading-relaxed text-white/45 tracking-wide">
            {LEGAL_LINE}
          </p>
        </div>
      </div>
    </footer>
  );
};
